import { last } from 'fxjs/es';

export const col = (name = '') => `${name}${G._en}`;
export const colAs = (name = '', alias) => `${name}${G._en} AS ${alias || last(name.split('.'))}`;
export const colCollabo = (name = '') => `${name}${G._collabo}${G._en}`;
export const colCollaboAs = (name = '', alias = last(name.split('.'))) =>
  `${name}${G._collabo}${G._en} AS ${alias}`;
export const colI18nAs = (name = '', alias, suffix = '_i18n', lang = T.lang) =>
  SQL`${CL(`${name}${suffix}`)} ->> ${lang} AS ${CL(alias || last(name.split('.')))}`;

export const colIntlAs = (name = '', alias, suffix = '_intl', lang = T.lang) =>
  colI18nAs(name, alias, suffix, lang);

export const colJsonbLang = (name, key) => SQL`${CL(`${name}`)} ->> ${`${key}${G._en}`}`;
